<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top" dir="rtl">
    <div class="container">
      <!-- Logo -->
      <router-link to="/" class="navbar-brand">
        <img src="@/assets/image/GameClubLogo.png" alt="logo" class="navbar-logo" />
      </router-link>

      <!-- Auth Buttons (Outside collapse for mobile) -->
      <div class="auth-buttons-mobile d-lg-none">
        <template v-if="showHeader">
          <router-link to="/Unsubscribes" class="btn btn-primary btn-sm">الغاء الاشتراك</router-link>
        </template>
        <template v-else>
          <button @click="gotoSpay" class="btn btn-primary btn-sm">إشتــراك</button>
          <router-link to="/Login" class="btn btn-primary btn-sm me-2">تسجيل الدخول</router-link>
        </template>
      </div>

      <!-- Mobile Toggler -->
      <button class="navbar-toggler" type="button" @click="toggleMenu" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Collapsible Content -->
      <div class="collapse navbar-collapse" :class="{ 'show': isMenuOpen }" id="navbarContent">
        <!-- Navigation Links -->
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link to="/" class="nav-link" active-class="active">الرئيسية</router-link>
          </li>
          <li class="nav-item">
            <router-link @click="toggleMenu" to="/Puzzles" class="nav-link">ألغاز</router-link>
          </li>
          <li class="nav-item">
            <router-link @click="toggleMenu" to="/Arcade" class="nav-link">تحدي</router-link>
          </li>
          <li class="nav-item">
            <router-link @click="toggleMenu" to="/Strategy" class="nav-link">أكشن</router-link>
          </li>
          <li class="nav-item">
            <router-link @click="toggleMenu" to="/Adventure" class="nav-link">مغامرة</router-link>
          </li>
          <li class="nav-item">
            <router-link @click="toggleMenu" to="/Sports" class="nav-link">رياضية</router-link>
          </li>
        </ul>

        <!-- Search Form -->
        <form class="d-flex search-form mx-lg-3">
          <div class="input-group">
            <input type="search" class="form-control" placeholder="بحث ..." aria-label="Search">
            <button class="btn btn-search" type="submit">
              <i class="feather-search"></i>
            </button>
          </div>
        </form>

        <!-- Auth Buttons (Desktop only) -->
        <div class="auth-buttons d-none d-lg-block">
          <template v-if="showHeader">
            <router-link to="/Unsubscribes" class="btn btn-primary">الغاء الاشتراك</router-link>
          </template>
          <template v-else>
            <button @click="gotoSpay" class="btn btn-primary">إشتــراك</button>
            <router-link to="/Login" class="btn btn-primary ms-2">تسجيل الدخول</router-link>
          </template>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useCookie } from 'vue-cookie-next';
import { HTTPSPA } from '@/Api/http-Spay';

const showHeader = ref(false);
const isMenuOpen = ref(false);
const router = useRouter();
const cookie = useCookie();

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const checkSubscription = async (msisdn) => {
  try {
    const response = await HTTPSPA.post(`CheckLogin.php?username=${msisdn}&serviceId=2222&operatorID=2`);
    const { MINTUES, message, status, responseCode } = response.data;

    if (status == 1 && MINTUES > 0) {
      const options = { expire: 60 * MINTUES };
      cookie.setCookie('status', status, options);
      cookie.setCookie('msisdn', msisdn, options);
      cookie.setCookie('remming_minutes', MINTUES, options);
      showHeader.value = true;
    } else if (status == 0 && responseCode == 118) {
      const options = { expire: 60 * MINTUES };
      cookie.setCookie('status', status, options);
      cookie.setCookie('msisdn', msisdn, options);
      cookie.setCookie('remming_minutes', MINTUES, options);
      showHeader.value = true;
    } else if (responseCode == 117 && message == 'this MSISDN is not subscribed to the service') {
      clearCookies();
      showHeader.value = false;
    } else {
      clearCookies();
      showHeader.value = false;
    }
  } catch (error) {
    console.error('Error checking subscription:', error);
  }
};

const clearCookies = () => {
  cookie.removeCookie('status');
  cookie.removeCookie('msisdn');
  cookie.removeCookie('remming_minutes');
};

watchEffect(() => {
  const msisdn = cookie.getCookie('msisdn');
  const status = cookie.getCookie('status');
  if (msisdn && status) {
    checkSubscription(msisdn);
    showHeader.value = true;
  } else {
    clearCookies();
    showHeader.value = false;
  }
});

const gotoSpay = () => {
  window.open('http://sudanipay.com/subscription/la3btna/La3btna', '_self');
};
</script>

<style scoped>
/* Base navbar styles */
.navbar {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 1rem;
}

.navbar-toggler {
  background-color: #044871;
  border-color: transparent;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

.navbar-logo {
  height: 32px;
  max-width: 120px;
}

/* Navigation links */
.navbar-nav {
  margin-left: auto;
}

.nav-link {
  color: #044871;
  font-weight: 500;
  padding: 0.5rem 1rem;
  transition: color 0.2s ease;
}

.nav-link:hover, .nav-link.active {
  color: #83cbce;
}

/* Search form */
.search-form {
  max-width: 300px;
  width: 100%;
}

.search-form .form-control {
  border-radius: 20px 0 0 20px;
  border: 1px solid #e0e0e0;
  padding-right: 1rem;
}

.btn-search {
  border-radius: 0 20px 20px 0;
  background: #044871;
  color: white;
  border: none;
  padding: 0.375rem 1rem;
}

.btn-search:hover {
  background: #033d5f;
}

/* Auth buttons */
.btn-primary {
  background: #044871;
  border: 1px solid #83cbce;
  color: white;
  border-radius: 5px;
  padding: 0.375rem 1rem;
  font-size: 0.875rem;
}

.btn-primary:hover {
  background: #033d5f;
  border-color: #6bb1b4;
}

/* Mobile auth buttons */
.auth-buttons-mobile {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0.5rem;
}

.auth-buttons-mobile .btn {
  padding: 0.25rem 0.75rem;
  font-size: 0.8125rem;
  white-space: nowrap;
}

/* Responsive styles */
@media (max-width: 991.98px) {
  .navbar-collapse {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    /* background: white; */
    background: linear-gradient(0deg, #097ABD 0, #005C93);
    padding: 1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  .navbar-nav {
    margin-left: 0;
    text-align: right;
  }

  .search-form {
    margin: 1rem 0;
    max-width: 100%;
  }

  .auth-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .auth-buttons .btn {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .navbar-logo {
    height: 26px;
    max-width: 90px;
  }

  .navbar {
    padding: 0.375rem;
  }
}

/* RTL Specific Adjustments */
[dir="rtl"] .navbar-nav {
  padding-right: 0;
}

[dir="rtl"] .dropdown-menu {
  text-align: right;
  right: 0;
  left: auto;
}

[dir="rtl"] .search-form .form-control {
  border-radius: 0 20px 20px 0;
}

[dir="rtl"] .btn-search {
  border-radius: 20px 0 0 20px;
}

/* Animation for mobile menu */
.navbar-collapse {
  transition: transform 0.3s ease-in-out;
}

.navbar-collapse.show {
  transform: translateY(0);
}

.navbar-collapse:not(.show) {
  transform: translateY(0px);
}
</style>
